import PropTypes from "prop-types";
import FaceAndBodyCarousel from "../FaceAndBodyCarousel";
import { MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL } from "./constants";

const withFaceAndBodyCarousel = WrappedComponent => {
  const WithFaceAndBodyCarousel = ({ itemCount, carouselProps, ...rest }) => {
    let faceAndBodyCarousel = null;
    if (
      carouselProps !== null &&
      itemCount >= MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL
    ) {
      faceAndBodyCarousel = <FaceAndBodyCarousel {...carouselProps} />;
    }

    return (
      <WrappedComponent
        {...{
          ...rest,
          itemCount,
          faceAndBodyCarousel
        }}
      />
    );
  };

  WithFaceAndBodyCarousel.propTypes = {
    itemCount: PropTypes.number.isRequired,
    carouselProps: PropTypes.object
  };

  return WithFaceAndBodyCarousel;
};

export default withFaceAndBodyCarousel;
